import React, { useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import {
    Routes,
    Route,
    Navigate,
    useNavigate,
    useLocation,
} from "react-router-dom";
import VoiceCloningIntroduction from "./VoiceCloningIntroduction";
import VoiceCloningProcess from "./VoiceCloningProcess";
import VoiceCloningUpload from "./VoiceCloningUpload";
import VoiceCloningStepper from "./VoiceCloningStepper";
import VoiceCloningUploadProcess from "./VoiceCloningUploadProcess";

const steps = [
    {
        label: "Introduction",
        path: "introduction",
        component: VoiceCloningIntroduction,
    },
    { label: "Upload", path: "upload", component: VoiceCloningUpload },

    { label: "Process", path: "process", component: VoiceCloningUploadProcess },
];

function VoiceCloning() {
    const navigate = useNavigate();
    const location = useLocation();
    const [uploadData, setUploadData] = useState(null);

    const handleNext = (data) => {
        const currentIndex = steps.findIndex((step) =>
            location.pathname.includes(step.path)
        );
        if (currentIndex < steps.length - 1) {
            setUploadData((prevData) => ({ ...prevData, ...data }));
            navigate(steps[currentIndex + 1].path);
        }
    };

    const handleBack = () => {
        const currentIndex = steps.findIndex((step) =>
            location.pathname.includes(step.path)
        );
        if (currentIndex > 0) {
            navigate(steps[currentIndex - 1].path);
        }
    };
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
            }}
        >
            <Box sx={{ flexGrow: 1, display: "flex", p: 3 }}>
                <Box sx={{ minWidth: "250px", mr: 4 }}>
                    <Card>
                        <CardContent>
                            <VoiceCloningStepper steps={steps} />
                        </CardContent>
                    </Card>
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                    <Card>
                        <CardContent>
                            <Routes>
                                {steps.map((step) => (
                                    <Route
                                        key={step.path}
                                        path={step.path}
                                        element={
                                            <step.component
                                                onNext={handleNext}
                                                onBack={handleBack}
                                                {...uploadData}
                                            />
                                        }
                                    />
                                ))}
                                <Route
                                    path="*"
                                    element={
                                        <Navigate to="introduction" replace />
                                    }
                                />
                            </Routes>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </Box>
    );
}

export default VoiceCloning;
